import {ReactNode} from "react";

export function SelectedEntitySection({heading, children}: {heading: string, children: ReactNode}) {
  return (
    <div>
      <p className='text-gray-500 text-sm py-2 sticky top-0'>{heading}</p>
      <div className='flex flex-col gap-3'>
        {children}
      </div>
    </div>
  )
}